import React from "react";

const Grid = () => {
  return <div>Grid</div>;
};

export default Grid;
